import React, { Fragment, useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import ReactTable from 'react-table-v6'
import TableSpin from '../TableSpin'
import TableHeader from './Header'
import FilterButton from '../Buttons/FilterButton'
import RefreshButton from '../Buttons/RefreshButton'
import CSVExportButton from '../../elements/Buttons/csvExportButton'
import { strVal } from '../../modules/Utils'
import { Button, Checkbox, Layout, Popover } from 'antd'
import { isEmpty, set } from 'lodash'
import emptyData from '../../assets/img/illustrations/undraw_empty_xct9.svg'
import styled from 'styled-components'

const { Content } = Layout
/***
 CustomTable :
 hide => hide buttons vv
 :: att => create  (bool) (default == false) send true or component to hide
 :: att => refresh (bool) (default == false) send true to hide
 :: att => filter  (bool) (default == false) send true to hide
 show => show new buttons
 :: att => extraColumns (default == false) send false to show
 :: att => csv
 :: show     (bool)  (default == false) send true to show
 :: fileName (string)                    file name where of the csv file
 :: disabled (bool)  (default == false) send true to disable
 columns => columns attributes vv
 :: att => zIndex (int) (default == 0) sort columns order based on this value

 ***/
const Image = styled.img`
  margin: 20px;
  display: block;
  margin-left: auto;
  margin-right: auto;
  width: 280px;
`

const H3 = styled.h2`
  text-align: center !important;
`
const FullHeightContent = styled(Content)`
  margin: 24px 16px;
  padding: 24px;
  min-height: 200px;
`
const filterMethod = (filter, row) =>
  strVal(row, filter.id).toUpperCase().trim().includes(strVal(filter, 'value').toUpperCase().trim())

function CustomTable(props) {
  const {
    CreateButton,
    ExtraButtons,
    ExtraOptionsButtons,
    hide,
    isFilterable,
    show,
    fetching,
    fetch,
    loading,
    withRef,
    columns,
    data,
    rows,
    tableMinHeight,
    csvColumns,
  } = props
  const [filterable, setFilterable] = useState(isFilterable)
  let i = 1
  const indexedColumns = columns.map((c) => ({ zIndex: i++, ...c }))
  let extraColumns = indexedColumns.filter((c) => c.hideable === true)
  let alwaysVisibleColumns = indexedColumns.filter((c) => c.hideable !== true)
  //options for gear button
  const [gearOptions] = useState(
    extraColumns.map((c) => ({
      value: c.accessor,
      label: c.hideText || c.Header, // In case Header is React component then you need to provide a text
    }))
  )
  //currently selected options
  const [columnsSelection, setColumnSelection] = useState(
    extraColumns.filter((c) => !c.hideDefault === true).map((c) => c.accessor)
  )
  const displayedColumns = [
    ...alwaysVisibleColumns,
    ...columnsSelection.map((cs) => extraColumns.find((c) => c.accessor === cs)),
  ].sort((a, b) => a.zIndex - b.zIndex)
  if (extraColumns.length > 0) set(show, 'extraColumns', true)
  return (
    <Fragment>
      <TableHeader>
        {!(hide.create === true) && <CreateButton />}
        <ExtraButtons />
        <div style={{ float: 'right' }}>
          {!(hide.refresh === true) && (
            <RefreshButton float={'right'} disabled={loading || fetching} onClick={fetch} />
          )}
          {!(hide.filter === true) && (
            <FilterButton
              enabled={filterable}
              style={{ marginRight: 10, float: 'right' }}
              onClick={() => setFilterable((f) => !f)}
            />
          )}
          {show.extraColumns === true && (
            <Popover
              trigger="click"
              content={
                <Checkbox.Group
                  options={gearOptions}
                  defaultValue={columnsSelection}
                  onChange={(c) => setColumnSelection(c)}
                />
              }
              placement="left"
              title="Extra Columns">
              <Button
                type={'dashed'}
                icon={'setting'}
                size={'small'}
                style={{ marginRight: 10, float: 'right' }}
              />
            </Popover>
          )}
          {show.csv && (
            <CSVExportButton
              data={data}
              columns={displayedColumns}
              // columns={csvColumns || displayedColumns}
              fileName={show.csv.fileName}
              disabled={show.csv.disabled}
            />
          )}
          <ExtraOptionsButtons />
        </div>
      </TableHeader>
      <ReactTable
        defaultPageSize={rows || 10}
        style={tableMinHeight || { minHeight: '512px' }}
        {...props}
        data={data}
        noDataText={
          !fetching && (
            <FullHeightContent>
              <Image src={emptyData} alt={'No data'} />
              <H3>No Data</H3>
            </FullHeightContent>
          )
        }
        filterable={filterable}
        multiSort={true}
        loading={fetching || loading}
        LoadingComponent={TableSpin}
        className="-highlight"
        defaultFilterMethod={filterMethod}
        ref={withRef}
        pageSizeOptions={[3, 5, 10, 20, 25, 50, 100]}
        columns={displayedColumns.map((c) => ({
          style: { textAlign: 'center', fontSize: 12 },
          ...c,
        }))}
      />
    </Fragment>
  )
}

CustomTable.propTypes = {
  columns: PropTypes.array,
  data: PropTypes.array,
  CreateButton: PropTypes.element | PropTypes.func,
  ExtraButtons: PropTypes.element,
  ExtraOptionsButtons: PropTypes.element,
  hide: PropTypes.shape({
    refresh: PropTypes.bool,
    filter: PropTypes.bool,
  }),
  fetching: PropTypes.bool,
  loading: PropTypes.bool,
  fetch: PropTypes.bool,
  filterable: PropTypes.bool,
  isFilterable: PropTypes.bool,
  setFilterable: PropTypes.func,
}
CustomTable.defaultProps = {
  fetching: false,
  isFilterable: false,
  CreateButton: Fragment,
  ExtraButtons: Fragment,
  ExtraOptionsButtons: Fragment,
  fetch: () => console.error('Not Implemented'),
  data: [],
  columns: [],
  csvColumns: [],
  hide: { create: false },
  show: {
    extraColumns: false,
    csv: false,
  },
}

export default CustomTable
